import CustomerLogos from "@/components/marketing/CustomerLogos";
import { SectionContainer } from "./HomePrimitives";
import { LOGO_MARQUEE } from "./homeContent";

export default function LogoMarquee() {
  return (
    <SectionContainer padding="logos">
      <CustomerLogos>
        {LOGO_MARQUEE.lead}
        <br />
        {LOGO_MARQUEE.count}
      </CustomerLogos>
    </SectionContainer>
  );
}
